import TableActionMenu from "../../../components/table-action-menu/table-action-menu";
import { Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const RateColumns = (handleDelete, openEdit) => {
  return [
    {
      dataKey: "name",
      name: "Rate Card Name",
      align: "left",
      render: (cellData, rowData) => {
        // true if any role in any group has rate < 1
        const hasLowRate = rowData.serviceGroups?.some((group) =>
          group.roles.some((role) => Number(role.rate) < 1)
        );

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            {rowData.isDefault && (
              <Typography className="default-pill" variant="body1">
                Default
              </Typography>
            )}

            {hasLowRate && (
              <WarningAmberIcon
                fontSize="small"
                color="warning"
                titleAccess="Contains a rate below 1"
              />
            )}

            <span>{cellData}</span>
          </div>
        );
      },
    },
    {
      dataKey: "dateCreated",
      name: "Created",
      align: "left",
    },
    {
      name: "",
      dataKey: "actions",
      width: "10px",
      align: "center",
      render: (cellData, rowData) => (
        <TableActionMenu
          noBorder
          options={[
            {
              title: "Edit Rate Card",
              onClick: () => openEdit(rowData),
            },
            // {
            //   title: "Delete Rate Card",
            //   onClick: () => handleDelete(rowData.id, rowData.name),
            // },
          ]}
        />
      ),
    },
  ];
};

export default RateColumns;
